import { Action, createReducer, on } from '@ngrx/store';
import * as cityActions from '../actions/index';
import { produceOn } from '../../immer.helper';


// Define the state interface
export interface CitiesState {
  cities?: any[];
  isLoading?: boolean;
  error?: any;
}

// Define the initial state
export const initialState: CitiesState = {
  cities: [],
  isLoading: false,
  error: null,
};

// Create the reducer using Immer's produceOn to handle state mutations
const citiesReducer = createReducer(
  initialState,
  produceOn(cityActions.getCities, (draft) => {
    draft.isLoading = true;
    draft.error = null;
  }),
  produceOn(cityActions.getCitiesSuccess, (draft, { data }) => {
    draft.cities = data;
    draft.isLoading = false;
  }),
  produceOn(cityActions.getCitiesFailure, (draft, { error }) => {
    draft.isLoading = false;
    draft.error = error;
  })
);

// Export the reducer function
export function reducer(
  state: CitiesState | undefined,
  action: Action
): CitiesState {
  return citiesReducer(state, action);
}
